import { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import AdminDashboardLayout from "../../../Components/AdminDashboard/AdminDashboardLayout";
import Loading from 'react-fullscreen-loading';
import { toast } from "react-hot-toast";
import { Button } from "react-bootstrap";
import DataTable from 'react-data-table-component';
import ShowTime from "../../../utils/ShowTime/ShowTime";
import countryList from 'react-select-country-list';
import Select from 'react-select'
import CustomLoader from "../../../utils/DataTableLoader/CustomLoader";
import {FaEdit} from "react-icons/fa";
import { Link } from 'react-router-dom';
import { Can, useAuth } from "../../../authentication/AuthContext";
import TruncatedText, { TruncatedTextTooltip, DateCell, COLUMN_WIDTHS } from "../../../Components/TruncatedText/TruncatedText";

export default function UserProfiles() {
  const { can } = useAuth();
  const navigate = useNavigate();
  const [TableData,setTableData]= useState([]);
  const [screenloader,setScreenloader] = useState(true);
  const [TotalRecords,setTotalRecords] = useState();
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [sortBy,setSortBy] = useState("created_at");
  const [sortOrder,setSortOrder] = useState("desc");
  const [pending, setPending] = useState(true);
  const [type, setType] = useState(""); 

  const initialFilters = {
    'l.created_at': { operator: '', value: '' },
    email: { operator: '', value: '' },
    Product: { operator: '', value: '' },
    organization: { operator: '', value: '' }
  };
  const [filters, setFilters] = useState(initialFilters);
  const [createdAt, setCreatedAt] = useState("");
  const [email, setEmail] = useState("");
  const [organization , setOrganization] = useState("");
  const [country, setCountry] = useState([]);
  const CountriesList = useMemo(() => countryList().getData(), []);
  
  const handleFiltersChange = (key, value, operator) => {
    setFilters(prevFilters => ({
      ...prevFilters,
      [key]: {
        operator: operator,
        value: value
      }
    }));
  };
  // useEffect(() => {
  //   if (type) {
  //     handleFiltersChange("type", type, "="); // Always include type in the filters
  //   }
  // }, [type]);
  
  const handleFiltersReset = () =>{
    setFilters(initialFilters);
    setCreatedAt("");
    setEmail("");
    setOrganization("");
    setCountry([]);
  }

  const handleEnterKeyPress = (e) => {
      var value =e.target.value;
      if(value!==""){
        value = `%${value}%`
      }
      if (e.key === 'Enter') {
        handleFiltersChange(e.target.id, value, 'LIKE')    
      }
  };

  const handleCopyEmailList = () =>{
    const emails = TableData.map(license => license.email);
    const emailList = (emails.join(', '));
    try {
      navigator.clipboard.writeText(emailList);
      toast.success(`${emails.length} Emails copied to clipboard!`);
    } catch (error) {
      toast.error('Failed to copy email list to clipboard');
    }
  };
  const columns = [
      { 
        name: "Actions", 
        // Hidden entirely rather than left as an empty column: omit drops the
        // header as well as the cells.
        omit: !(can('admin.user_profiles.update')),
        sortable: false, 
        cell: row=>(<>
                      <Can permission="admin.user_profiles.update">
                        <FaEdit
                          data-tooltip-id="userprofile-index-edit"
                          data-tooltip-content="edit userprofile"
                          data-tooltip-place="top"
                          className="edit-icon"
                          onClick={() => {
                            navigate(`/Admin/UserProfiles/${row.id}/edit`, {
                              replace: false,
                            });
                          }}
                        />
                      </Can>
                    </>
                    )
      },
    {
      name: 'ID',
      selector: row => row.id,
    },
    {
      name: 'Type',
      selector: row => row.type,
      sortField: "type",
      sortable: true,
      cell: row => <div style={{ whiteSpace: 'pre-wrap' }}>{row.type ? row.type : '-'}</div>,
    },
    {
      name: 'Name',
      minWidth: `${COLUMN_WIDTHS.name}px`,
      selector: row => row.name,
      sortField: "name",
      sortable: true,
      cell: row => <TruncatedText text={row.name} maxWidth={COLUMN_WIDTHS.name} />,
    },
    {
      name: 'Email',
      minWidth: `${COLUMN_WIDTHS.email}px`,
      selector: row => row.email,
      sortField: "email",
      sortable: true,
      cell: row => <TruncatedText text={row.email} maxWidth={COLUMN_WIDTHS.email} />,
    },
    {
      name: 'Phone',
      minWidth: `${COLUMN_WIDTHS.phone}px`,
      selector: row => row.phone,
      sortField: "phone",
      sortable: true,
      cell: row => <TruncatedText text={row.phone} maxWidth={COLUMN_WIDTHS.phone} />,
    },
    {
      name: 'Address 1',
      minWidth: `${COLUMN_WIDTHS.address}px`,
      selector: row => row.address_line_1,
      sortField: "address_line_1",
      sortable: true,
      cell: row => <TruncatedText text={row.address_line_1} maxWidth={COLUMN_WIDTHS.address} />,
    },
    {
      name: 'Address 2',
      minWidth: `${COLUMN_WIDTHS.address}px`,
      selector: row => row.address_line_2,
      sortField: "address_line_2",
      sortable: true,
      cell: row => <TruncatedText text={row.address_line_2} maxWidth={COLUMN_WIDTHS.address} />,
    },

    {
      name: 'Designation',
      minWidth: `${COLUMN_WIDTHS.name}px`,
      selector: row => row.designation,
      sortField: "designation",
      sortable: true,
      cell: row => <TruncatedText text={row.designation} maxWidth={COLUMN_WIDTHS.name} />,
    },
    {
      name: 'Organization',
      minWidth: `${COLUMN_WIDTHS.organization}px`,
      selector: row => row.organization,
      sortField: "organization",
      sortable: true,
      cell: row => <TruncatedText text={row.organization} maxWidth={COLUMN_WIDTHS.organization} />,
    },
    {
      name: 'Country',
      minWidth: `${COLUMN_WIDTHS.country}px`,
      selector: row => row.country,
      sortField: "country",
      sortable: true,
      cell: row => <TruncatedText text={row.country} maxWidth={COLUMN_WIDTHS.country} />,
    },
    {
      name: 'Payment Method',
      selector: row => row.preferred_payment_method,
      sortField: "preferred_payment_method",
      sortable: true,
      cell: row => <div>{row.preferred_payment_method ? row.preferred_payment_method: '-'}</div>,
    },
    {
      name: 'Payment Term',
      selector: row => row.preferred_payment_term,
      sortField: "preferred_payment_term",
      sortable: true,
      cell: row => <div>{row.preferred_payment_term ? row.preferred_payment_term: '-'}</div>,
    },
    {
      name: 'Created At',
      minWidth: `${COLUMN_WIDTHS.date}px`,
      selector: row => row.created_at,
      sortField: "created_at",
      sortable: true,
      cell: row => <DateCell value={ShowTime(row.created_at)} />,
    },
    {
      name: 'Updated At',
      minWidth: `${COLUMN_WIDTHS.date}px`,
      selector: row => row.updated_at,
      sortField: "updated_at",
      sortable: true,
      cell: row => <DateCell value={ShowTime(row.updated_at)} />,
    },
  ];

const getUserProfilesList = async () => {
  // console.log(page,pageSize,sortBy,sortOrder,filters)
  try {
    const formattedFilters = Object.keys(filters)
    .filter(key => filters[key].value) // Filter out falsy values
    .map((key, index) => ({
      [`filters[${index}][column]`]: key,
      [`filters[${index}][operator]`]: filters[key].operator,
      [`filters[${index}][value]`]: filters[key].value,
    }))
    .reduce((acc, obj) => ({ ...acc, ...obj }), {});

    const response = await axios.get(`${process.env.REACT_APP_API_URL}/admin/user_profiles`, {
      params: {
        limit: pageSize,
        page: page,
        sort_by:sortBy,
        sort_order:sortOrder,
        ...formattedFilters
      },
      headers: {
        'access-token': localStorage.getItem('accessToken'),
      },
    });
    setScreenloader(false);
    setPending(false);
    if (response.data.status) {
      const total = response.data.meta.pagination.total;
      setTotalRecords(total);
      setTableData(response.data.user_profiles);
      // console.log(response.data.user_profiles);

    } else {
      toast.error('Something Went Wrong');
      console.log(response.data);
    }
  } catch (error) {
    setScreenloader(false);
    setPending(false);
    if (error.response?.data?.message) {
      toast.error(error.response.data.message);
    } else {
      console.error(error);
      toast.error('Something Went Wrong');
    }
  }
};
useEffect(() => {
  setPending(true);
  getUserProfilesList();
}, [filters, page, pageSize, sortBy, sortOrder, type]);

const now = new Date();

  const startOfDay = new Date(now);
  startOfDay.setHours(0, 0, 0, 0);

  const startOf3DaysAgo = new Date(now);
  startOf3DaysAgo.setDate(startOf3DaysAgo.getDate() - 2);
  startOf3DaysAgo.setHours(0, 0, 0, 0);

  const endOf3DaysAfter = new Date(now);
  endOf3DaysAfter.setDate(endOf3DaysAfter.getDate() + 3);
  endOf3DaysAfter.setHours(0, 0, 0, 0);

  const startOf1WeekAgo = new Date(now);
  startOf1WeekAgo.setDate(startOf1WeekAgo.getDate() - 7);
  startOf1WeekAgo.setHours(0, 0, 0, 0);

  const endOf1WeekAfter = new Date(now);
  endOf1WeekAfter.setDate(endOf1WeekAfter.getDate() + 7);
  endOf1WeekAfter.setHours(0, 0, 0, 0);

  const startOf1MonthAgo = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
  startOf1MonthAgo.setHours(0, 0, 0, 0);

  const endOf1MonthAfter = new Date(now.getFullYear(), now.getMonth() + 1, now.getDate());
  endOf1MonthAfter.setHours(0, 0, 0, 0);

  const startOf2MonthAgo = new Date(now.getFullYear(), now.getMonth() - 2, now.getDate());
  startOf2MonthAgo.setHours(0, 0, 0, 0);

  const endOf2MonthAfter = new Date(now.getFullYear(), now.getMonth() + 2, now.getDate());
  endOf2MonthAfter.setHours(0, 0, 0, 0);


  return (
    <div>
      <AdminDashboardLayout />
      <Loading loading={screenloader} background="#fff" loaderColor="#883484" />
      <div className='content-page-bg'>
        <div className='content-page'>
          <div className='content'>

            <div className="row">
              <h2>User Profiles</h2>
            </div>
            <div className="col-6 col-md-12 mb-3 d-flex justify-content-end align-items-end">
            <Can permission="admin.user_profiles.create">
            <Link to="/Admin/UserProfiles/new">
              <Button className="btn admin-btn" onClick={handleFiltersReset} variant="primary" >
                 + Add User Profiles
              </Button>
            </Link>
            </Can>
          </div>
            <div className="filters row">
              <div className="col-md-3 mb-3">
                <div className="input-group">
                  <input
                      type="email"
                      className="form-control"
                      id="email"
                      placeholder='Email'
                      value={email}
                      onChange={e =>{setEmail(e.target.value);}}
                      onKeyDown={handleEnterKeyPress}
                  />
                  {email && (
                    <span
                      className="input-group-text"
                      role="button"
                      onClick={() => handleEnterKeyPress({ key: 'Enter', target: { id: 'email', value: email } })}
                    >
                      Apply
                    </span>
                  )}
                </div>
              </div>

              <div className="col-md-3 mb-3">
                <div className="input-group">
                  <input
                      type="text"
                      className="form-control"
                      id="organization"
                      placeholder='Organization'
                      value={organization}
                      onChange={e =>{setOrganization(e.target.value);}}
                      onKeyDown={handleEnterKeyPress}
                  />
                  {organization && (
                    <span
                      className="input-group-text"
                      role="button"
                      onClick={() => handleEnterKeyPress({ key: 'Enter', target: { id: 'organization', value: organization } })}
                    >
                      Apply
                    </span>
                  )}
                </div>
              </div>
              <div className="col-md-3 mb-3" >
                <Select
                placeholder="Type"
                options={[
                  { value: null, label: "All"},
                  { value: "Reseller", label: "Reseller" },
                  { value: "User", label: "User" },
                ]}
                onChange={(e) => {
                  setType(e);handleFiltersChange('type', e.value, '=')
                }}
              />

              </div>


              <div className="col-md-3 mb-3">
                <Select placeholder="Country" options={CountriesList} value={country} onChange={(e) => {setCountry(e);handleFiltersChange('country', e.label, '=')}} />
              </div>

              <div className="col-md-3 mb-3">
                <Select
                  placeholder="Created At"
                  options={[
                      { value: "", label:"All" },
                      { value: startOfDay.toISOString(), label:"Today" },
                      { value: startOf3DaysAgo.toISOString(), label: "Past 3 Days" },
                      { value: startOf1WeekAgo.toISOString(), label: "Within a Week" },
                      { value: startOf1MonthAgo.toISOString(), label:"Witin a Month" },
                      { value: startOf2MonthAgo.toISOString(), label:"Within 2 Months" },
                  ]}
                  value={createdAt}
                  onChange={(e) => {setCreatedAt(e);handleFiltersChange('created_at', e.value, '>=')}}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-6 col-md-6 mb-3 d-flex">
                <Button onClick={handleCopyEmailList} variant="primary" className="admin-btn">
                  Copy Email List
                </Button>
              </div>
              <div className="col-6 col-md-6 mb-3 d-flex justify-content-end align-items-end">
                <Button onClick={handleFiltersReset} variant="primary"  className="admin-btn">
                  Clear all Filters
                </Button>
              </div>
            </div>
            <div className="row d-flex d-sm-none">
              <p>Total Records: <strong>{TotalRecords}</strong></p>
            </div>

            <div className="table-wrapper">
              <DataTable
                //data
                columns={columns}
                data={TableData}
                //style
                dense
                direction="auto"
                highlightOnHover
                noHeader
                persistTableHead
                pointerOnHover
                responsive
                subHeaderAlign="right"
                subHeaderWrap
                progressPending={pending}
                progressComponent={<CustomLoader />}
                // conditionalRowStyles={conditionalRowStyles}
                //pagination
                pagination
                paginationServer 
                paginationPerPage={pageSize} 
                paginationTotalRows={TotalRecords} 
                paginationRowsPerPageOptions={[10,20,50,100,150]}
                onChangePage={(page) => setPage(page)} 
                onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {setPageSize(currentRowsPerPage); setPage(currentPage)}} 
                sortServer
                onSort={(column, sortDirection) => {setSortBy(column.sortField); setSortOrder(sortDirection);}}
              />
            </div>
          </div>
        </div>
      </div>
      <TruncatedTextTooltip />
    </div>
  );
}    
